// 将一段时间内的多次函数调用合并为一次
export function reduceCall (fn, wait, context) {
  let timer = null

  return function () {
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context || this, arguments)
    }, wait)
  }
}

export const safeGet = (obj, path, def) => {
  let val = obj
  let keys = path.split('.')
  try {
    keys.forEach(key => {
      val = val[key]
    })
  } catch (e) {
    return def
  }
  return val
}

// 通过path获取到描述符
export const safeGetDesc = (obj, path) => {
  let val = obj
  let keys = path.split('.')
  let frontKeys = keys.slice(0, -1)
  let endKey = keys.slice(-1)[0]
  try {
    frontKeys.forEach(key => {
      val = val[key]
    })
  } catch (e) {
    return {
      o: {},
      k: endKey
    }
  }
  return {
    o: val,
    k: endKey
  }
}
